<template>
    <div>
        <b-modal
            id="add-package-popup"
            ref="modal"
            :title="title"
            size="md"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-2"
                            label="Title"
                            label-for="title"
                        >
                            <b-form-input
                                id="title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    max: 50,
                                }"
                                name="title"
                                type="text"
                                :class="{
                                    'is-invalid':
                                        errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Title"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-5"
                            label="Package Type"
                            label-for="type"
                        >
                            <b-form-select
                                v-model="formData.type"
                                v-validate="{ required: true }"
                                name="type"
                                :options="typeOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-5"
                            label="Currency"
                            label-for="currency"
                        >
                            <b-form-select
                                v-model="formData.currency"
                                v-validate="{ required: true }"
                                name="currency"
                                :options="currencyOptions"
                            ></b-form-select>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-1"
                            label="Price per Profile"
                            label-for="price"
                        >
                            <b-form-input
                                id="price"
                                v-model="formData.price"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    // regex: /^\S*$/,
                                }"
                                name="price"
                                type="decimal"
                                :class="{
                                    'is-invalid': errors.has('price'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Price/Profile"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-1"
                            label="First Time Price"
                            label-for="firstTimePrice"
                        >
                            <b-form-input
                                id="firstTimePrice"
                                v-model="formData.firstTimePrice"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    // regex: /^\S*$/,
                                }"
                                name="firstTimePrice"
                                type="decimal"
                                :class="{
                                    'is-invalid': errors.has('firstTimePrice'),
                                }"
                                autocomplete="no"
                                placeholder="Enter First Time Price"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-6">
                        <b-form-group
                            id="input-group-1"
                            label="Renwal Price"
                            label-for="renewalPrice"
                        >
                            <b-form-input
                                id="renewalPrice"
                                v-model="formData.renewalPrice"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    // regex: /^\S*$/,
                                }"
                                name="renewalPrice"
                                type="decimal"
                                :class="{
                                    'is-invalid': errors.has('renewalPrice'),
                                }"
                                autocomplete="no"
                                placeholder="Enter Renewal Price"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12 row-min-space">
                        <div class="row">
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="Minimum Onboarding"
                                    label-for="min"
                                >
                                    <b-form-input
                                        id="min"
                                        v-model="formData.onboardings.min"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="min"
                                        type="number"
                                        :class="{
                                            'is-invalid':
                                                errors.has('min'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Minimum Onboarding"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-6">
                                <b-form-group
                                    id="input-group-2"
                                    label="Maximum Onboarding"
                                    label-for="max"
                                >
                                    <b-form-input
                                        id="max"
                                        v-model="formData.onboardings.max"
                                        v-validate="{
                                            required: true,
                                            max: 50,
                                        }"
                                        name="max"
                                        type="number"
                                        :class="{
                                            'is-invalid':
                                                errors.has('max'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Maximum Onboarding"
                                    ></b-form-input>
                                </b-form-group>
                            </div>

                            <div class="col-md-12">
                                <b-form-group
                                    id="input-group-2"
                                    label="Stripe Price Id"
                                    label-for="stripePriceId"
                                >
                                    <b-form-input
                                        id="stripePriceId"
                                        v-model="formData.stripePriceId"
                                        v-validate="{
                                            max: 100,
                                            required: true,
                                        }"
                                        name="stripePriceId"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('stripePriceId'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Stripe Price Id"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            <div class="col-md-12">
                                <b-form-group
                                    id="input-group-2"
                                    label="Stripe Product Id"
                                    label-for="stripeProductId"
                                >
                                    <b-form-input
                                        id="stripeProductId"
                                        v-model="formData.stripeProductId"
                                        v-validate="{
                                            max: 100,
                                            required: true,
                                        }"
                                        name="stripeProductId"
                                        type="text"
                                        :class="{
                                            'is-invalid':
                                                errors.has('stripeProductId'),
                                        }"
                                        autocomplete="no"
                                        placeholder="Enter Stripe Product Id"
                                    ></b-form-input>
                                </b-form-group>
                            </div>
                            
                            <div class="col-md-6">
                                <b-form-group label="Status">
                                    <b-form-radio-group
                                        v-model="formData.status"
                                        :options="statusOptions"
                                        name="Status"
                                    ></b-form-radio-group>
                                </b-form-group>
                            </div>

                            <div class="col-md-3">
                                <b-form-checkbox class="mt-3" v-model="formData.isCustom">
                                    <span class="mt-2">
                                        Is Custom ?
                                    </span>
                                </b-form-checkbox>
                            </div>
                            <div class="col-md-3">
                                <b-form-checkbox class="mt-3" v-model="formData.hideFromPricingPage">
                                    <span class="mt-2">
                                        Hide From Pricing ?
                                    </span>
                                </b-form-checkbox>
                            </div>



                        </div>
                    </div>

                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        :disabled="loading"
                        btn-variant="link"
                    ></base-button>
                </div>
                <base-toast></base-toast>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import _ from 'lodash'
import resource from '@/api/resource'

const packageResource = new resource('configurations/packages')

export default {
    components: {
        Multiselect,
    },

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        parentName: { type: String },
        selectedItem: { type: Object },
        reload: { type: Function },
        setSelectedItem: { type: Function },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            formData: this.initializeFormData(),
            typeOptions: [
                {text: 'Pro', value: 'pro'},
                {text: 'Premium', value: 'premium'},
            ],
            currencyOptions: [
                {text: 'USD', value: 'USD'},
                {text: 'GBP', value: 'GBP'},
            ],
            statusOptions: [
                {text: 'Active', value: 'active'},
                {text: 'Archived', value: 'archived'},
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user']),
        title() {
            return this.selectedItem ? 'Modify Package' : 'Add Package'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            console.log("selectedItem", value)
            if (value) {
                Object.assign(this.formData, value)
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
    }, // End of Component > watch

    mounted() {
    },
    methods: {
        initializeFormData() {
            return {
                title: '',
                type: 'pro',
                period: 'yearly',
                onboardings: {
                    min: '',
                    max: '',
                },
                currency: 'USD', //USD, GBP
                price: '',
                firstTimePrice: '',
                renewalPrice: '',
                period: 'yearly',
                description: [],
                isCustom: false,
                hideFromPricingPage: false,
                status: "active",
                stripeProductId: '',
                stripePriceId: '',
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                let encryptedData = this.$encryptData({...this.formData});
                const tempRequest = { data: encryptedData }
                try {
                    let response = null;
                    if (this.selectedItem && this.selectedItem._id) {
                        response = await packageResource.update(this.selectedItem._id, tempRequest)
                    } else {
                        response = await packageResource.store(tempRequest)
                    }
                    this.$store.commit('setSuccess', response.data.message)
                    this.initializeFormData();
                    this.onHidden()
                    this.reload()
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                    const msg = typeof error == 'string' ? error : error.message; 
                    this.$store.commit('setError', msg)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.setSelectedItem(null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
    },
}
</script>
